import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-100 px-4">
      <h1 className="text-6xl font-bold text-red-600">404</h1>
      <p className="text-2xl mt-4">Oops! Page Not Found</p>
      <p className="text-gray-600 mt-2">The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="mt-6 px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition">
        Go to Homepage
      </Link>
    </div>
  );
};

export default NotFound;
